import backend from '@common/backend';

const BASE = '/curators';

type AttachmentImageType = {
	type: 'image';
	fallback: string;
	image_url: string;
	original_width?: number;
	original_height?: number;
};

type AttachmentFileType = {
	type: 'file';
	title: string;
	asset_url: string;
	file_size?: number;
	mime_type?: string;
};

type SendScheduledMessageAttachment = AttachmentImageType | AttachmentFileType;

interface SendScheduledMessageProps {
	channel_cid: string;
	scheduled_at: string;
	duplicate_to_email: boolean;
	message: string;
	attachments?: SendScheduledMessageAttachment[];
}

export interface IGetCuratorsQuery {
	search?: string;
	page?: number;
	limit?: number;
}

export const getCurators = async (query: IGetCuratorsQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const createCurator = async (data: any) => backend.post(`${BASE}`, data);

export const getCurator = async (id: number) => backend.get(`${BASE}/${id}`);

export const removeCurator = async (id: number) => backend.delete(`${BASE}/${id}`);

export const saveCurator = async (id: number, data: any) => backend.post(`${BASE}/${id}`, data);

export const getCuratorGroups = async (query: IGetCuratorsQuery) =>
	backend.get(`${BASE}/groups`, { params: query });

export const updateProgramGroupsChannelsSettings = async (id: number, data: any) =>
	backend.post(`${BASE}/groups/programGroups/${id}/channels`, data);

export const getGroupsList = async (query: { service_id: number }) =>
	backend.get(`${BASE}/channels/groupsList`, { params: query });

export const getProgramsList = async (query: { service_id: number }) =>
	backend.get(`${BASE}/channels/programsList`, { params: query });

export const sendBulkMessage = async (data: any) =>
	backend.post(`${BASE}/channels/sendBulkMessage`, data);

export const updateChannel = async (channelCid: string, data: any) =>
	backend.post(`${BASE}/channels/${channelCid}/update`, data);

export const sendScheduledMessage = async (data: SendScheduledMessageProps) =>
	backend.post(`${BASE}/channels/sendScheduledMessage`, data);
